import { Outlet, useLocation } from "react-router-dom";
import {
  resolveManageFirmIdForRedux,
  useEnsureManageFirmLoaded,
} from "../../hooks/useEnsureManageFirmLoaded";

/**
 * Unique layout for routes under /ManageFirm: synchronizes the firm in Redux
 * for direct access and deep links; the sheets use <Outlet /> without repeating the hook.
 */
const ManageFirmLayout = () => {
  const { pathname } = useLocation();
  const firmId = resolveManageFirmIdForRedux(pathname);
  useEnsureManageFirmLoaded(firmId);
  return <Outlet />;
};

export default ManageFirmLayout;
